module.exports = __webpack_public_path__ + "img/qrcode-1667.2027f3cd.png";